import PrimeVue from 'primevue/config';
import Timeline from 'primevue/timeline';
import Message from 'primevue/message';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Ripple from 'primevue/ripple';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';
import Card from 'primevue/card';
import Password from 'primevue/password';
import OverlayPanel from 'primevue/overlaypanel';
import InputSwitch from 'primevue/inputswitch';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import FileUpload from 'primevue/fileupload';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Avatar from 'primevue/avatar';
import Calendar from 'primevue/calendar';
import SelectButton from 'primevue/selectbutton';
import Tooltip from 'primevue/tooltip';
import ScrollPanel from 'primevue/scrollpanel';
import InputOtp from 'primevue/inputotp';
import Fieldset from 'primevue/fieldset';
import Badge from 'primevue/badge';
import Textarea from 'primevue/textarea';
import InlineMessage from 'primevue/inlinemessage';
import Stepper from 'primevue/stepper';
import StepperPanel from 'primevue/stepperpanel';
import TabMenu from 'primevue/tabmenu';
import SpeedDial from 'primevue/speeddial';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import MultiSelect from 'primevue/multiselect';
import Tag from 'primevue/tag';
import MeterGroup from 'primevue/metergroup';
import ProgressBar from 'primevue/progressbar';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import Editor from 'primevue/editor';
import Checkbox from 'primevue/checkbox';
import ConfirmationService from 'primevue/confirmationservice';
import ProgressSpinner from 'primevue/progressspinner';
import ConfirmDialog from 'primevue/confirmdialog';
import Skeleton from 'primevue/skeleton';
import Menubar from 'primevue/menubar';
import Menu from 'primevue/menu';
import FloatLabel from 'primevue/floatlabel';
import SplitButton from 'primevue/splitbutton';
import 'primeicons/primeicons.css';
import '/node_modules/primeflex/primeflex.css';
import 'primevue/resources/themes/lara-light-blue/theme.css';
import BadgeDirective from 'primevue/badgedirective';
import { localeES } from '../modules/bsa/helpers/localeES';
import PanelMenu from 'primevue/panelmenu';
import Slider from 'primevue/slider';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Breadcrumb from 'primevue/breadcrumb';
export default {
   install(app) {
      app.use(PrimeVue, { ripple: true, locale: localeES });
      app.use(ToastService);
      app.use(ConfirmationService);

      app.component('DataTable', DataTable);
      app.component('Column', Column);
      app.component('ColumnGroup', ColumnGroup);
      app.component('Row', Row);
      app.component('Timeline', Timeline);
      app.component('Message', Message);
      app.component('Sidebar', Sidebar);
      app.component('Button', Button);
      app.component('Dropdown', Dropdown);
      app.component('InputText', InputText);
      app.component('Password', Password);
      app.component('InputNumber', InputNumber);
      app.component('IconField', IconField);
      app.component('InputIcon', InputIcon);
      app.component('Dialog', Dialog);
      app.component('RadioButton', RadioButton);
      app.component('Card', Card);
      app.component('OverlayPanel', OverlayPanel);
      app.component('InputSwitch', InputSwitch);
      app.component('Accordion', Accordion);
      app.component('AccordionTab', AccordionTab);
      app.component('FileUpload', FileUpload);
      app.component('InputGroup', InputGroup);
      app.component('InputGroupAddon', InputGroupAddon);
      app.component('SelectButton', SelectButton);
      app.component('Avatar', Avatar);
      app.component('Calendar', Calendar);
      app.component('ScrollPanel', ScrollPanel);
      app.component('InputOtp', InputOtp);
      app.component('Fieldset', Fieldset);
      app.component('Textarea', Textarea);
      app.component('InlineMessage', InlineMessage);
      app.component('Stepper', Stepper);
      app.component('StepperPanel', StepperPanel);
      app.component('TabMenu', TabMenu);
      app.component('SpeedDial', SpeedDial);
      app.component('Toast', Toast);
      app.component('MultiSelect', MultiSelect);
      app.component('Tag', Tag);
      app.component('MeterGroup', MeterGroup);
      app.component('ProgressBar', ProgressBar);
      app.component('TriStateCheckbox', TriStateCheckbox);
      app.component('Checkbox', Checkbox);
      app.component('Editor', Editor);
      app.component('ProgressSpinner', ProgressSpinner);
      app.component('ConfirmDialog', ConfirmDialog);
      app.component('Divider', Divider);
      app.component('Skeleton', Skeleton);
      app.component('Menubar', Menubar);
      app.component('Menu', Menu);
      app.component('PanelMenu', PanelMenu);
      app.component('FloatLabel', FloatLabel);
      app.component('SplitButton', SplitButton);
      app.component('Badge', Badge);
      app.component('Slider', Slider);
      app.component('TabView', TabView);
      app.component('TabPanel', TabPanel);
      app.component('Breadcrumb', Breadcrumb);
      app.directive('tooltip', Tooltip);
      app.directive('ripple', Ripple);
      app.directive('badge', BadgeDirective);
   },
};
